import { lowerFirst } from 'lodash-es';

export const OBJECT_TYPE_KEYS = ['PROJECT', 'MEASURING_POINT'] as const;
export type ObjectTypeKey = (typeof OBJECT_TYPE_KEYS)[number];

export class ObjectTypeInfo {
    /**
     * @param type the name of the object type when used in GraphQL enums.
     * @param objectName the name that is being used inside GraphQL queries.
     * @param translation the translated version.
     * @param isProject boolean that determines if this type is a project or not.
     */
    constructor(
        public type: ObjectTypeKey,
        public objectName: string,
        public translation: string,
        public isProject: boolean
    ) {}

    toString(): string {
        return `${this.constructor.name}.${this.type}`;
    }

    get objectNameLowerFirst(): string {
        return lowerFirst(this.objectName);
    }
}

export const ObjectType = Object.freeze({
    PROJECT: new ObjectTypeInfo('PROJECT', 'Project', gettext('PROJECT'), true),
    MEASURING_POINT: new ObjectTypeInfo(
        'MEASURING_POINT',
        'MeasuringPoint',
        gettext('MEASURING_POINT'),
        false
    ),
});

/**
 * Returns a project or measuring point `ObjectTypeInfo` instance
 * depending on the `isProject` parameter.
 */
export function getObjectType(isProject: boolean): ObjectTypeInfo {
    return isProject ? ObjectType.PROJECT : ObjectType.MEASURING_POINT;
}
